export default "__VITE_ASSET__D$SCXoF0__"